import React, { useState, useEffect, useContext } from 'react';
import { RouteComponentProps } from '@reach/router';
import { observer } from 'mobx-react-lite';
import { StoreContext } from '@/stores';
import './index.less';
import _ from 'lodash';
import { Icon, Steps, Button } from 'antd';
import { BlockLoading2 } from '@/components';
import DataChoose from './component/data-choose';
import DataAnalyse from './component/data-analyse';
const { Step } = Steps;

const DataManageImport: React.FC<RouteComponentProps> = () => {
    const store = useContext(StoreContext);
    const DMIStore = store.getDefaultDataManageImportStore();
    const {
        fetchDataImportConfig,
        dataManageImportConfig,
        configFetchLoading,
    } = DMIStore;
    useEffect(() => {
        fetchDataImportConfig();
    }, []);
    const [stepCurrent, setStepCurrent] = useState(0);
    const nextStep = () => {
        setStepCurrent(stepCurrent + 1);
    };
    const prevStep = () => {
        setStepCurrent(stepCurrent - 1);
    };
    const stepRenderData = [
        {
            title: '选择数据',
            key: 'data',
            icon: <Icon type="file" />,
            content: <DataChoose nextStep={nextStep} />,
        },
        {
            title: '字段映射',
            key: 'analyse',
            icon: <Icon type="exception" />,
            content: <DataAnalyse nextStep={nextStep} prevStep={prevStep} />,
        },
        {
            title: '导入结果',
            key: 'import',
            icon: <Icon type="cloud-upload" />,
            content: (
                <div className="final-import-tips">
                    <p>导入文件成功，请在5至10分钟后前往线索页查看导入成果～</p>
                    <Button
                        type="primary"
                        onClick={() => {
                            setStepCurrent(0);
                        }}
                    >
                        继续导入
                    </Button>
                </div>
            ),
        },
    ];
    return (
        <div className="dmi-page-content">
            {configFetchLoading ? (
                <BlockLoading2 />
            ) : (
                <div className="dmi-step-content">
                    <Steps current={stepCurrent}>
                        {_.map(stepRenderData, step => {
                            return (
                                <Step
                                    key={step.key}
                                    icon={step.icon}
                                    title={step.title}
                                />
                            );
                        })}
                    </Steps>
                </div>
            )}
            <div className="dmi-action-content">
                {stepRenderData[stepCurrent].content || null}
            </div>
        </div>
    );
};

export default observer(DataManageImport);
